import { Box, Image } from "@chakra-ui/react";
import imgContent from "../../../assets/images/content/bg/content-management.png";
import tContent from "../../../assets/images/content/bg/content-tablet-management.png";
import mContent from "../../../assets/images/content/bg/content-mobile-management.png";

import { useContext } from "react";
import { ScreenContext } from "../../../components/ScreenProvider";


const Management = () => {
  const screen = useContext(ScreenContext).style;
  const contents = {
    pc: imgContent,
    mobile: mContent,
    tablet: tContent,
  };

  return (
    <Box w={"100%"}>
      <Image 
        src={contents[screen]} 
        w={"100%"} 
        alt="" 
      />
    </Box>
  );
};

export default Management;